import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Box from '@/components/Box';
import Arrival from '@/components/Arrival';
import Swipe from '@/utils/swipe';
import cx from '@/utils/cx';
import useStyle from './style';

const Toast = ({
  visibility,
  children,
  fullWidth,
  position,
  timeout,
  onVisibilityChange,
  ...rest
}) => {
  const classes = useStyle({ position, fullWidth });
  const boxRef = useRef();
  const swipe = useRef();

  useEffect(() => {
    swipe.current = Swipe();
    swipe.current.setElement(boxRef.current);

    swipe.current.beforeSwipe(() => {
      boxRef.current.style.transitionDuration = '0s';
    });

    swipe.current.whileSwipe((pos, diff) => {
      const translateY = diff.y;
      boxRef.current.style.transform = `translateY(${translateY}px)`;
    });

    swipe.current.afterSwipe((pos, diff) => {
      boxRef.current.style.transitionDuration = null;
      boxRef.current.style.transform = null;

      const shouldClose = (position === 'top' && diff.y < -20) || (position === 'bottom' && diff.y > 20);
      if (shouldClose) {
        onVisibilityChange(false);
      }
    });

    return () => {
      swipe.current.off();
    };
  }, [position]);


  useEffect(() => {
    let setTimeOutId = null;

    if (visibility) {
      if (timeout > 0) {
        setTimeOutId = setTimeout(() => {
          onVisibilityChange(false);
        }, timeout);
      }
      swipe.current.on();
    } else if (!visibility) {
      clearTimeout(setTimeOutId);
      boxRef.current.style.transitionDuration = null;
      boxRef.current.style.transform = null;
      swipe.current.off();
    }

    return () => {
      clearTimeout(setTimeOutId);
    };
  }, [visibility]);

  return (
    <Arrival in={visibility}>
      {(status) => (
        <Box
          ref={boxRef}
          className={cx(classes.toast, status)}
          {...rest}>
          {children}
        </Box>
      )}
    </Arrival>
  );
};

Toast.propTypes = {
  visibility: PropTypes.bool,
  /* if fullWidth set to true toast render without margin */
  fullWidth: PropTypes.bool,
  /* if timeout set to 0 toast closable will be false */
  timeout: PropTypes.number,
  position: PropTypes.oneOf(['top', 'bottom']),
  onVisibilityChange: PropTypes.func,
};

Toast.defaultProps = {
  visibility: false,
  fullWidth: false,
  timeout: 3000,
  position: 'top',
  onVisibilityChange: (() => {}),
};

export default Toast;
